import { useCallback } from 'react'
import { useEditingContext } from '../../../context/EditingContext'
import { useUser } from '../../../fetchData/queries/useUser'

interface CellParams {
  node?: {
    data: {
      editable: boolean
    }
  }
  column: {
    getColId: () => string
  }
}

const useCheckIfSheetEditable = () => {
  const { readOnlyMode } = useEditingContext()
  const { data } = useUser()

  const checkIfEditable = useCallback(
    (params: CellParams): boolean => {
      const rowIsEditable: boolean = params.node?.data.editable ?? false
      const isCommentColumn = params.column.getColId() === 'comment'

      if (rowIsEditable) {
        // readonlymode used to view comments in historic sheets
        if (readOnlyMode) {
          return isCommentColumn
        } else {
          const writePermission = data?.scopes?.['sheet_write'] ?? false
          return writePermission
        }
      }

      return false
    },
    [data?.scopes, readOnlyMode]
  )

  return checkIfEditable
}

export default useCheckIfSheetEditable
